import { createContext } from "react";

const UserContext = createContext({
    defaultUser:"Default user"
});

export default UserContext;

